module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"box-body\">\n                <div class=\"box-divider m-a-0\"></div>\n                <div class=\"table-responsive m-b-lg\">\n                    <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/players/playerProfile/playerMatches/playerMatches.html
// module id = 837
// module chunks = 0